export const isObjectEmpty = (obj: { [key: string]: any }): boolean => {
    return Object.keys(obj).length === 0;
};
